import { Directive, ElementRef, Inject, Input, LOCALE_ID, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { ENVIRONMENT_TOKEN } from '../injection.tokens';
import { WebComponentOptionsService } from '../service/webcomponent-options.service';
import { getFormattedCurrencyString, isNullOrEmpty } from '../function/custom-function';

type MoneyOptions = {
  showDualCurrency?: string | number;
  primaryCurrencyCode?: string | number;
  secondaryCurrencyCode?: string | number;
  currencyConversionRate?: string | number;
  showCurrencyAfterValue?: string | number;
};
@Directive({
  selector: '[appMoney]'
})
export class MoneyDirective implements OnChanges {
  environment: any;
  showDualCurrency: boolean = false;
  primaryCurrencyCode: string = '';
  secondaryCurrencyCode: string = '';
  currencyConversionRate: number = 1;
  showCurrencyAfterValue: boolean = false;
  private optionsLoaded: boolean = false;
  private pendingViewUpdate: boolean = false;
  @Input() appMoney!: number;
  @Input() onlyPrimaryCurrency: boolean = false;
  @Input() digitsInfo: string = '1.2-2';
  @Input() useNewLine: boolean = true;

  constructor(
    @Inject(LOCALE_ID) private _localeId: string,
    @Inject(ENVIRONMENT_TOKEN) private env: any,
    private el: ElementRef,
    private renderer: Renderer2,
    private webComponentOptionsService: WebComponentOptionsService
  ) {
    this.environment = env;
    const options$ = this.webComponentOptionsService.getOptionsIfNeeded() as any;

    options$.subscribe((value: MoneyOptions | null) => {
      if (value) {
        this.showDualCurrency = Boolean(Number(value.showDualCurrency ?? 0));
        this.primaryCurrencyCode = isNullOrEmpty(value.primaryCurrencyCode) ? this.environment.constants.currency : String(value.primaryCurrencyCode);
        this.secondaryCurrencyCode = String(value.secondaryCurrencyCode);
        this.currencyConversionRate = Number(value.currencyConversionRate ?? 1);
        this.showCurrencyAfterValue = Boolean(Number(value.showCurrencyAfterValue ?? 0));
      } else {
        this.primaryCurrencyCode = this.environment.constants.currency;
        this.showCurrencyAfterValue = true;
      }

      this.optionsLoaded = true;
      this.renderer.addClass(this.el.nativeElement, 'text-end');

      if (this.pendingViewUpdate) {
        this.pendingViewUpdate = false;
        this.updateView();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('appMoney' in changes) {
      if (!this.optionsLoaded) {
        this.pendingViewUpdate = true;
        return;
      }

      this.updateView();
    }
  }

  private updateView(): void {
    if (this.appMoney == null) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');
      return;
    }
    if (this.onlyPrimaryCurrency || !this.showDualCurrency) {
      this.el.nativeElement.innerHTML = getFormattedCurrencyString({
        value: this.appMoney,
        locale: this._localeId,
        primaryCurrencyCode: this.primaryCurrencyCode,
        useNewLine: this.useNewLine,
        showCurrencyAfterValue: this.showCurrencyAfterValue
      });
      return;
    }
    this.el.nativeElement.innerHTML = getFormattedCurrencyString({
      value: this.appMoney,
      locale: this._localeId,
      showDualCurrency: this.showDualCurrency,
      primaryCurrencyCode: this.primaryCurrencyCode,
      secondaryCurrencyCode: this.secondaryCurrencyCode,
      currencyConversionRate: this.currencyConversionRate,
      useNewLine: this.useNewLine,
      showCurrencyAfterValue: this.showCurrencyAfterValue
    });
  }
}
